import { render, staticRenderFns } from "./ChipLabel.vue?vue&type=template&id=874c6924&scoped=true"
import script from "./ChipLabel.vue?vue&type=script&lang=js"
export * from "./ChipLabel.vue?vue&type=script&lang=js"
import style0 from "./ChipLabel.vue?vue&type=style&index=0&id=874c6924&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "874c6924",
  null
  
)

export default component.exports